import { OfferHistory } from '../../../../../shared/models/offer-history.model';
import { Component, OnDestroy, OnInit, Input, ViewChild } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { OfferModalAction } from '../../../../../shared/directives/offer-modal-action/offer-modal-action';
import { Cancel, MakeOffer, AnalyticsService, CurrencyFormatService } from 'smartauction-frontend-micro-library';
import {
  BuyErrors,
  ConfigurationState,
  FinanceSource,
  LaunchDarklyService,
  multiLanguageAlphaNumericRegexHelper,
  UserService
} from 'remarketing-angular-library';
import { get } from 'lodash';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { Store } from '@ngxs/store';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { TranslocoDirective, TranslocoService } from '@jsverse/transloco';
import { HigherExistingOfferComponent } from '../../higher-existing-offer/higher-existing-offer.component';
import { CharacterCountComponent, CharacterCountDirective, CurrencyInputComponent, InputConfig } from 'remarketing-ui-components-lib';
import { CommonModule } from '@angular/common';
import { OfferModalsHeaderComponent } from 'src/shared/ui/comment/modal-actions/offer-header/offer-modals-header.component';
import { VehicleChangedWarningComponent } from '../../vehicle-changed-warning/vehicle-changed-warning.component';
import { ModalCloseComponent } from 'src/shared/ui/comment/modal-actions/modal-close/modal-close.component';
import { ActionSubmittingComponent } from 'src/shared/ui/comment/modal-actions/action-submitting/action-submitting.component';
import { ActionSubmittedComponent } from 'src/shared/ui/comment/modal-actions/action-submitted/action-submitted.component';
import { DripFeeSource, DripPricingService } from 'src/shared/services/drip-pricing/public-api';
import { FeeToolTipService } from 'src/shared/services/feetooltip/feetooltip.service';
import {
  ModalPriceBreakdownComponent,
  modalTotalDueOf,
  showsTransportationFee
} from 'src/shared/components/modal-price-breakdown/modal-price-breakdown.component';
import {
  ModalPriceBreakdownPattern,
  ModalPriceBreakdownRow,
  ModalPriceBreakdownTranslations
} from 'src/shared/components/modal-price-breakdown/modal-price-breakdown.types';

@Component({
    selector: 'app-initial-offer',
    templateUrl: './initial-offer.component.html',
    styleUrls: ['./initial-offer.component.scss'],
    imports: [
        TranslocoDirective,
        CommonModule,
        OfferModalsHeaderComponent,
        VehicleChangedWarningComponent,
        FormsModule,
        ReactiveFormsModule,
        CurrencyInputComponent,
        CharacterCountComponent,
        ModalCloseComponent,
        HigherExistingOfferComponent,
        ActionSubmittingComponent,
        ActionSubmittedComponent,
        CharacterCountDirective,
        RouterLink,
        ModalPriceBreakdownComponent
    ]
})
export class InitialOfferComponent extends OfferModalAction implements OnInit, OnDestroy {
  @Input() offerHistory: OfferHistory[];
  @Input() financeSource: FinanceSource;
  form: UntypedFormGroup;
  sellingDisclosureUrl: string;
  private readonly destroyed$ = new Subject();
  characterCountData: any;
  private intialOffer = true;
  showValidAmountErrorMsg: boolean;

  initialOfferTranlations = {
    enterValidAmount: '',
    viewOnlyPurchaseActionError: '',
    errorMsgTitle: '',
    msgDescriptionImportant: '',
    msgDescriptionBySelecting: '',
    msgDescriptionMakeOffer: '',
    msgDescriptionPartOne: '',
    msgDescriptionPartTwo: '',
    msgDescriptionTransportaion: ''
  };

  inputConfig: InputConfig = {
    inputClass: 'form-control modal__form-control stockwave-bid-buy-amount',
    inputName: 'offerAmount',
    inputFormControlName: 'offerAmount',
    inputAttrAriaLabelledBy: 'offer-amount-label offer-amount-error',
    thousandSeparator: '',
    isFrenchCanadian: this.isFrenchCanadian
  };

  @ViewChild(HigherExistingOfferComponent) higherExistingOfferModal: HigherExistingOfferComponent;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private route: ActivatedRoute,
    private readonly analyticsService: AnalyticsService,
    private readonly store: Store,
    private readonly _launchDarklyService: LaunchDarklyService,
    private readonly translocoService: TranslocoService,
    private readonly launchDarklyService: LaunchDarklyService,
    private readonly userService: UserService,
    private readonly dripPricingService: DripPricingService,
    private readonly feeToolTipService: FeeToolTipService,
    private readonly currencyFormatService: CurrencyFormatService
  ) {
    super();
  }

  get isCanadianTenantEnabled(): boolean {
    return this.launchDarklyService.getFeatureFlag('canadianTenantEnabled', false);
  }

  get isFrenchCanadian(): boolean {
    const frenchLanguage = this.translocoService.getActiveLang().includes('fr');
    return frenchLanguage && this.isCanadianTenantEnabled;
  }

  get highestOfferAmount(): any {
    return get(this.offerHistory, '[0].offer.highestOfferAmount', {});
  }

  get isViewOnly() {
    return this.store.selectSnapshot(ConfigurationState.hasRole('View_Only'));
  }

  get showBackendError() {
    return this.errorMessage && !this.showValidAmountErrorMsg && !this.isViewOnly;
  }

  get showGeneralErrorMessage() {
    if (this.errorMessage) {
      return this.isViewOnly
        ? this.initialOfferTranlations.viewOnlyPurchaseActionError
        : this.initialOfferTranlations.errorMsgTitle;
    }
  }

  get errorLocation(): 'modal' | 'offer' {
    if (!this.errorMessage) {
      return null;
    }

    if (
      this.errorMessage === BuyErrors.MSG_BUY_002 ||
      this.errorMessage === BuyErrors.MSG_BUY_003 ||
      this.errorMessage === BuyErrors.MSG_BUY_004 ||
      this.errorMessage === BuyErrors.MSG_BUY_005 ||
      this.errorMessage === BuyErrors.MSG_BUY_007
    ) {
      return 'offer';
    }
    return 'modal';
  }

  ngOnInit() {
    this.getTranslations();
    this.form = this.formBuilder.group({
      offerAmount: ['', Validators.required],
      offerComment: ['']
    });

    this.store
      .select(state => state.configuration.configuration)
      .pipe(takeUntil(this.destroyed$))
      .subscribe(configuration => {
        this.sellingDisclosureUrl = get(configuration, 'sellingDisclosureUrl', null);
      });
  }

  getTranslations() {
    const keyParams = {
      error: {},
      UIComponents: {},
      'common.currency': {},
      'vehicles.initialOffer': {}
    };
    this.translocoService
      .selectTranslateObject(keyParams)
      .pipe(takeUntil(this.destroyed$))
      .subscribe(translatedObj => {
        this.initialOfferTranlations.enterValidAmount = translatedObj[0].enterValidAmount;
        this.initialOfferTranlations.viewOnlyPurchaseActionError = translatedObj[0].viewOnlyPurchaseActionError;
        this.characterCountData = translatedObj[1].characterCount;
        this.inputConfig.thousandSeparator = translatedObj[2].thousandSeparator;
        this.initialOfferTranlations.errorMsgTitle = translatedObj[3].errorMsgTitle;
        this.initialOfferTranlations.msgDescriptionImportant = translatedObj[3].msgDescriptionImportant;
        this.initialOfferTranlations.msgDescriptionBySelecting = translatedObj[3].msgDescriptionBySelecting;
        this.initialOfferTranlations.msgDescriptionMakeOffer = translatedObj[3].msgDescriptionMakeOffer;
        this.initialOfferTranlations.msgDescriptionPartOne = translatedObj[3].msgDescriptionPartOne;
        this.initialOfferTranlations.msgDescriptionPartTwo = translatedObj[3].msgDescriptionPartTwo;
        this.initialOfferTranlations.msgDescriptionTransportaion = translatedObj[3].msgDescriptionTransportaion;
      });
  }

  get showSellingDisclosure(): boolean {
    return this._launchDarklyService.getFeatureFlag('disclosuresLinkEnabled', false);
  }

  get showVOCItems(): boolean {
    return this._launchDarklyService.getFeatureFlag('vocItemsEnabled', false);
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  get vehicleTitle() {
    const { modelYear = '', make = '', model = '', trim = ''} = this.item;
    return `${modelYear} ${make} ${model} ${trim} - VIN `;
  }

  get vin() {
    return this.item?.vin;
  }

  replaceInvalidCharacters(e) {
    e.target.value = multiLanguageAlphaNumericRegexHelper(e.target.value);
  }

  newOffer() {
    this.errorMessage = null;
    const offerAmount = this.parsedOfferAmount();
    const offerComment = this.form.get('offerComment').value;

    if (offerAmount) {
      if (offerAmount < this.highestOfferAmount && this.showVOCItems) {
        this.intialOffer = false;
        return;
      } else {
        if (this.isViewOnly) {
          this.errorMessage = 'W-REMPLT-AIS-VOU';
          return;
        }
        this.showValidAmountErrorMsg = false;
        this.event.emit(new MakeOffer(offerAmount, offerComment));
      }
    } else {
      this.errorMessage = BuyErrors.MSG_BUY_003;
      this.showValidAmountErrorMsg = true;
      const error = document.getElementById('offer-amount');
      error.focus();

      // send tracking data
      const inventoryItemUuid = get(this.route, 'snapshot.parent.children[0].params.inventoryItemUuid', null);
      const analyticsPayload = new MakeOffer(offerAmount, offerComment);
      this.analyticsService.track('customEvent', {
        name: analyticsPayload.type.split('Offer').join('') + ' Offer',
        attr: this.analyticsService.createOfferModalEventAnalyticsPayload(
          analyticsPayload,
          this.errorMessage,
          inventoryItemUuid
        )
      });

      this.analyticsService.track(
        'customError',
        this.errorMessage,
        null,
        this.analyticsService.createOfferModalEventAnalyticsPayload(
          analyticsPayload,
          this.errorMessage,
          inventoryItemUuid
        )
      );
    }

    this.form.reset();
  }

  isFinanceSourceFeeIncluded() {
    return this.financeSource.feeAmount != null && this.financeSource.feeAmount != 0;
  }

  /**
   * The offer amount as digits.
   *
   * newOffer(), continue() and the breakdown's base amount all read this, so the number submitted and
   * the number totalled are the same number. Three parsers for one money field is the defect this
   * removes -- the breakdown must not be a second opinion about what the buyer typed.
   *
   * The masked field already hands back separator-free digits (ngx-mask defaults
   * dropSpecialCharacters to true, and _removeMask strips the thousand separator before the value
   * reaches the form), so the strip below is not what makes today's behaviour correct -- it is what
   * keeps it correct if that ever changes. parseInt('59,000') is 59, which would be a wrong figure
   * under a binding-offer disclosure rather than an obvious failure.
   *
   * String() rather than a null check: form.reset() leaves the control null, which yields NaN here
   * exactly as the previous inline parseInt(null) did. newOffer()'s falsy guard rejects it and the
   * breakdown renders it as '$--'.
   */
  private parsedOfferAmount(): number {
    return parseInt(String(this.form?.get('offerAmount')?.value).replace(/[^\d]/g, ''), 10);
  }

  // ---------------------------------------------------------------------------
  // All-in pricing (drip pricing, Canada's Competition Act) -- M4.4, copy revised in M4.13
  //
  // Pattern B: the buyer names the amount, so there is no system-composed headline to decompose. The
  // currency field is projected into the breakdown's base-amount row and the total beneath it updates
  // as the buyer types, so the all-in figure their offer commits them to is on screen before they
  // submit rather than implied by "plus any applicable charges or fees".
  //
  // M4.4 left the disclosure prose alone and raised the wording as a copy decision for the story
  // owner. The comp (Figma 10493:16256) has since answered it: today's "Important: By selecting Make
  // Offer ..." paragraph is marked hidden and one sentence replaces it, below the breakdown, quoting
  // the total. See offerQuotedPriceDisplay for which total and why.
  // ---------------------------------------------------------------------------

  /** Prefix for the breakdown's generated ids, matching this modal's mom_* hooks. */
  readonly dripIdPrefix = 'mom_price';

  /** Pattern B: the base amount is the buyer's own, rendered as the projected currency field. */
  readonly additivePattern = ModalPriceBreakdownPattern.ADDITIVE;

  /**
   * The listing's fee schedule, forwarded by OfferModalsComponent.
   *
   * buyFee rather than bidItem.buyFee: this modal opens for vehicles that are not on the buyer's bid
   * list, where bidItem is undefined, so reading it directly would leave the breakdown off for the
   * majority of offers. See the field's comment on OfferModalAction for where the host gets it.
   */
  private get dripFeeSource(): DripFeeSource {
    return this.buyFee;
  }

  /**
   * The breakdown's base amount: what the buyer has typed, or undefined when the field is empty.
   *
   * undefined rather than 0, so an empty field renders the '$--' placeholder. A total of $0 under a
   * binding-offer disclosure is a materially wrong figure; a missing one is merely missing.
   */
  get dripOfferBaseAmount(): number | undefined {
    const parsed = this.parsedOfferAmount();
    return Number.isFinite(parsed) ? parsed : undefined;
  }

  /**
   * Two conditions only -- the flag and the fee source.
   *
   * Deliberately NOT gated on having an amount: the buyer types it, so an empty field is the normal
   * opening state and the breakdown has to be on screen to be typed into.
   *
   * The fee source is required because without it requiredFeesOf returns [] and the "total" would
   * equal the offer amount, presenting a bare offer as an all-in figure.
   *
   * Tested with hasFeePayload rather than `!!this.buyFee`. Truthiness is not the same question: `{}`
   * and `{ fees: null }` are both truthy and both carry no fees, so `!!` admits exactly the case the
   * paragraph above says it exists to exclude. hasFeePayload asks whether a fee COLLECTION arrived,
   * which is the condition that makes the total meaningful.
   *
   * Not requiredFeesOf(...).length either, and the service docblock says so explicitly: a payload that
   * arrived carrying no required fee must still render, with the all-in total legitimately equal to the
   * bare amount. Gating on the row count would withhold the breakdown from a correct zero-fee answer.
   *
   * And no unusable required fee. requiredFeesOf drops a fee whose amount is not finite, so the rows and
   * the TOTAL PURCHASE PRICE would be short by exactly the fee the buyer must pay -- the failure
   * hasUnusableRequiredFee exists to prevent. Buy Now, Withdraw and Counter catch it through
   * allInPriceOf; this modal has no all-in price of its own to check, because the buyer types the amount.
   */
  get showDripBreakdown(): boolean {
    return this.dripPricingService.isDripPricingEnabled
      && this.dripPricingService.hasFeePayload(this.dripFeeSource)
      && !this.dripPricingService.hasUnusableRequiredFee(this.dripFeeSource);
  }

  get dripTransportationFee(): number | undefined {
    return this.dripPricingService.transportationFeeOf(this.dripFeeSource);
  }

  /**
   * Governs the transportation row's companion paragraph. Same exported helper the row itself uses, so
   * the two cannot drift -- do not re-derive it as `fee > 0`.
   */
  get showTransportationDisclosure(): boolean {
    return showsTransportationFee(this.dripTransportationFee);
  }

  formatCurrency(currency, withCents?) {
    return this.currencyFormatService.formatCurrency(currency, withCents);
  }

  /**
   * The offer as a modal total: the required fees and optional transportation on top of the amount the
   * buyer typed. Not a second calculation of it -- the same exported helper the breakdown's own total
   * row uses, so the bold figure and the sentence beneath it cannot disagree by construction.
   */
  get dripOfferTotalDue(): number | undefined {
    return modalTotalDueOf(this.dripOfferBaseAmount, this.dripFeeRows, this.dripTransportationFee);
  }

  /**
   * The figure quoted in the binding-offer sentence, transportation INCLUDED.
   *
   * This reverses the note left here in M4.4, which argued the prose should not be reworded at all: for
   * an offer the fees genuinely ARE added on top of the amount the buyer names, so today's sentence is
   * not the misstatement it is under Buy Now. That reading stands on its own terms, but the comp answers
   * a different question -- what the buyer is bound to -- and answers it with the total. The matched Buy
   * Now pair (10360:9184 with transportation, 10360:9217 without) settles which figure that is: the
   * quoted number moves with the total between the two frames rather than staying on the all-in
   * subtotal. Quoting anything other than the figure in the row directly above would put a second,
   * unexplained number in the same panel, which is the defect this epic exists to remove.
   *
   * Falls back to the breakdown's own '$--' placeholder rather than formatting undefined: the buyer has
   * not typed an amount when the modal opens, and '$0' or '$NaN' inside a binding-offer disclosure is a
   * wrong figure rather than an obviously missing one. Same shape as the bid modal's and the counter
   * tab's, for the same reason -- in all three the buyer names the amount.
   *
   * withCents: false moves with the breakdown's [showCents]="false". The sentence quotes the figure in
   * the total row directly above it, so the two must be formatted the same way or the modal states one
   * number twice -- '$50,750.00' in prose under a '$50,750' band.
   */
  get offerQuotedPriceDisplay(): string {
    const amount = this.dripOfferTotalDue;
    return amount === undefined
      ? this.feeToolTipService.dripTranslations.textTotalPlaceholder
      : this.formatCurrency(amount, false);
  }


  /**
   * The fee rows, cached by content.
   *
   * Not an optimisation: translatedRequiredFeesOf maps a fresh array per call, and a template binding
   * is re-evaluated every change-detection pass, so returning it directly would hand the OnPush child
   * a new identity each pass and trip NG0100 in development builds. Keying on the serialised content
   * keeps the reference stable while still picking up a real change.
   */
  get dripFeeRows(): ModalPriceBreakdownRow[] {
    const rows = this.feeToolTipService.translatedRequiredFeesOf(this.dripFeeSource);
    const key = JSON.stringify(rows);
    if (key !== this.dripFeeRowsKey) {
      this.dripFeeRowsKey = key;
      this.dripFeeRowsCache = rows;
    }
    return this.dripFeeRowsCache;
  }

  /**
   * Cached by content for the same reason as dripFeeRows.
   *
   * labelBaseAmount is the drip bundle's ALL-CAPS labelOfferAmount rather than
   * vehicles.initialOffer.labelOfferAmount: the latter is 'Offer Amount' and is uppercased by the
   * label's text-uppercase class, which the breakdown's own label element does not carry. The fee
   * labels arrive asynchronously, so the key changes when they land and this cache does not stick to
   * the empty strings it sees first.
   */
  get dripBreakdownTranslations(): ModalPriceBreakdownTranslations {
    const drip = this.feeToolTipService.dripTranslations;
    const translations: ModalPriceBreakdownTranslations = {
      labelBaseAmount: drip.labelOfferAmount,
      // Unused by ADDITIVE, which has no sub-rows, but the contract is required.
      labelVehiclePrice: drip.labelVehiclePrice,
      labelTransportationFee: this.feeToolTipService.feeTranslations.TRANSPORTATION_FEE,
      // labelModalTotalDue, never labelTotalPurchasePrice: this total INCLUDES transportation while the
      // list-surface total excludes it. See the collision note on FeeToolTipService.dripTranslations.
      labelTotalDue: drip.labelModalTotalDue,
      textTotalPlaceholder: drip.textTotalPlaceholder,
      ariaLabelPriceComponents: drip.ariaLabelPriceComponents
    };
    const key = JSON.stringify(translations);
    if (key !== this.dripBreakdownTranslationsKey) {
      this.dripBreakdownTranslationsKey = key;
      this.dripBreakdownTranslationsCache = translations;
    }
    return this.dripBreakdownTranslationsCache;
  }

  /**
   * inputConfig with the labelling element the current layout actually renders.
   *
   * The field is projected out of its <label for="offer-amount"> and into the breakdown, which names
   * it with its own base-amount label instead, so the labelledby has to follow it. It is on the config
   * object rather than a template binding, so this cannot be passed as template context the way the
   * bid modal passes labelledBy to its stepper.
   *
   * Mutates and returns the SAME object rather than spreading a copy: a getter handing a template a
   * fresh object every change-detection pass trips NG0100 in development builds. One config also
   * means getTranslations()' thousandSeparator patch keeps landing on the object the template reads.
   *
   * Which makes this depend on CurrencyInputComponent NOT being OnPush, invisibly from here. RUIC
   * declares it with no changeDetection, so it is Default and re-evaluates
   * [attr.aria-labelledBy]="inputConfig.inputAttrAriaLabelledBy" on every pass -- the only reason
   * mutating a field on an unchanged reference reaches the DOM at all. If it were made OnPush nothing
   * here would fail loudly: the breakdown would still render, the field would still work, and the input
   * would keep pointing at whichever label existed when the config was first read, so a screen reader
   * would announce the wrong label for a money field and nothing would say so. The fix would not be
   * local either -- a fresh reference per change is the NG0100 problem above, so it needs a signal input
   * or an ngOnChanges on RUIC's side.
   */
  get offerAmountInputConfig(): InputConfig {
    const labelledBy = this.showDripBreakdown
      ? `${this.dripIdPrefix}_base_label offer-amount-error`
      : 'offer-amount-label offer-amount-error';
    if (this.inputConfig.inputAttrAriaLabelledBy !== labelledBy) {
      this.inputConfig.inputAttrAriaLabelledBy = labelledBy;
    }
    return this.inputConfig;
  }

  private dripFeeRowsKey: string;
  private dripFeeRowsCache: ModalPriceBreakdownRow[];
  private dripBreakdownTranslationsKey: string;
  private dripBreakdownTranslationsCache: ModalPriceBreakdownTranslations;

  continue() {
    const offerAmount = this.parsedOfferAmount();
    const offerComment = this.form.get('offerComment').value;
    this.event.emit(new MakeOffer(offerAmount, offerComment));
    this.form.reset();
    this.intialOffer = true;
  }

  back() {
    this.intialOffer = true;
  }

  cancel() {
    this.event.emit(new Cancel());
  }
}
